import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";
// import axios from "axios";

export const fetchGroupSpecificContractsStarted = () => {
  return {
    type: actionTypes.FETCH_GROUP_SPECIFIC_CONTRACTS_STARTED,
  };
};

export const fetchGroupSpecificContractsSuccess = (contracts) => {
  return {
    type: actionTypes.FETCH_GROUP_SPECIFIC_CONTRACTS_SUCCESS,
    contracts,
  };
};

export const fetchGroupSpecificContractsFailed = (errorMessage) => {
  return {
    type: actionTypes.FETCH_GROUP_SPECIFIC_CONTRACTS_FAILED,
    errorMessage: errorMessage,
  };
};

export const fetchGroupSpecificContracts = () => {
  return (dispatch) => {
    dispatch(fetchGroupSpecificContractsStarted());
    axios
      .get(
        serverconfigs.fetchGroupSpecificContractsUrl +
          `${localStorage.getItem(
            "clientGroupId"
          )}&clientId=${localStorage.getItem("clientId")}`
      )
      .then((response) => {
        console.log(response.data);
        dispatch(fetchGroupSpecificContractsSuccess(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(
              fetchGroupSpecificContractsFailed(error.response.data.message)
            );
          } else {
            dispatch(fetchGroupSpecificContractsFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(fetchGroupSpecificContractsFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(fetchGroupSpecificContractsFailed(error.message));
        } else {
          dispatch(fetchGroupSpecificContractsFailed(error.message));
        }
      });
  };
};
